import React from 'react';

const DataLoadingState = () => (
  <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-blue-50 dark:from-gray-900 dark:to-gray-800 py-8">
    <div className="max-w-4xl mx-auto px-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8">
        {/* Header Skeleton */}
        <div className="text-center mb-8">
          <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded-lg w-3/4 mx-auto mb-4 animate-pulse" />
          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-lg w-1/2 mx-auto mb-6 animate-pulse" />
          <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-lg w-48 mx-auto animate-pulse" />
        </div>

        {/* Form Fields Skeleton */}
        <div className="space-y-6">
          {[1, 2, 3, 4].map((i) => (
            <div key={i}>
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-32 mb-2 animate-pulse" />
              <div className="h-12 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse" />
            </div>
          ))}
          
          {/* Industry Dropdown Skeleton */}
          <div>
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-40 mb-2 animate-pulse" />
            <div className="h-12 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse" />
          </div>
        </div>

        {/* Info Box Skeleton */}
        <div className="mt-6 bg-gray-100 dark:bg-gray-700/50 p-4 rounded-lg animate-pulse">
          <div className="h-4 bg-gray-200 dark:bg-gray-600 rounded w-32 mb-3" />
          <div className="space-y-2">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="h-3 bg-gray-200 dark:bg-gray-600 rounded w-full" />
            ))}
          </div>
        </div>

        {/* Button Skeleton */}
        <div className="flex justify-center mt-8">
          <div className="h-12 bg-gray-200 dark:bg-gray-700 rounded-lg w-64 animate-pulse" />
        </div>
      </div>
    </div>
  </div>
);

export default DataLoadingState;


